export const environment = {
  production: true,
  baseUrl: "https://software.group-activa.com:44305/activa_server",
  idleBaseUrl: "https://software.group-activa.com:44305/notify",
  faceUrl: "https://activaapimanagement.azure-api.net/facial/",
  autoService: "https://sh-ci-staging-costapp.azurewebsites.net/#/", //"https://software.group-activa.com:44305/costapps/#/step-one/",
  riskService:
    "https://software.group-activa.com:44305/costapps/#/multirisque-habitation-step1/",
  condoleanceService:
    "https://software.group-activa.com:44305/costapps/#/condoleance-stepOne/",
  ladyStartupService:
    "https://software.group-activa.com:44305/costapps/#/ladyStartUp-step1/",
  chatbotService: "https://activa-chatbot.sevengps.net/full/#/seven/load",
  getInsurrance:
    "https://software.group-activa.com:44305/costapps/#/all-assurance/",
  googleTrackingId: "UA-199007566-1",
  loginUrl:
    "https://activaapimanagementprod.azure-api.net/a-surecover-admin-cmr",
  automobileBaseUrl:
    "https://activaapimanagementprod.azure-api.net/tarifiktor-prod-cmr",
  subscriptionBaseUrl:
    "https://activaapimanagementprod.azure-api.net/souscription-prod-cmr",
  printingBaseUrl:
    "https://activaapimanagementprod.azure-api.net/docgenerator-prod-cmr",
  automobileExtraBaseUrl:
    "https://activaapimanagementprod.azure-api.net/a-surecover-admin-cmr",
  assureBaseUrl:
    "https://activaapimanagementprod.azure-api.net/activaorassapiprod",
  assureAuthApiUser:
  "CMR-SH",
  autoAuthApiUser:
  "CMR-SH",
  assureAuthApiPassword: 
  "8ea12005690a9da03369d57863cf59ef",
  autoAuthApiPassword: 
  "753e566d76d34c60e675c5362644297d",
  identProcess: 
  "CMR-SH",
  ocpApimSubscriptionKey:
  "97e5d016f84c4a04b516052c9131181c",
  
  dashboardOrassBaseUrl: "https://souscription-cmr-prod.azurewebsites.net",

 //bankAssurance
  MSPolice: "https://apimgmtbancassprod.azure-api.net/cmr/prod/mspolice",
  MSBank: "https://apimgmtbancassprod.azure-api.net/cmr/prod/msbank",
  MSAggravation: "https://apimgmtbancassprod.azure-api.net/cmr/prod/agravation",
  bancassurance_api_username: "AssureCoverUser",
  bancassurance_api_password: "rp9KcYD6.vvnWMCtPkGK;6u#Tm4<9",
  Ocp_Apim_Subscription_Key:"ed95ac265f0f4e8d9aab45d51e3eb6b6"
};
